import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Image from "react-bootstrap/Image";
import Bnc from "../../Bnc.jpg";
import Natcash from "../../natcash_.jpeg";
import MonCash from "../../moncash_.jpeg";
import CreditCard from "../../debit_cards.jpeg";
import SEVIS_GRATIS from "../../SEVIS_GRATIS.jpeg";
import LajanCash from "../../LajanCash.png";
import Button from "react-bootstrap/Button";
import { FaRegCheckSquare } from "react-icons/fa";
import { toast } from "react-toastify";

const Mode_paiement = ({
  setCurrentform,
  currentform,
  infoPh,
  setInfoPh,
  candidatSelectionne,
  setCandidatSelectionne,
  etapesuivante,
  methode_paiement,
  setMethode_paiement,
  montant_a_payer,
}) => {
  const [date_trx, setDate_trx] = useState("");
  const [id_trx, setId_trx] = useState("");
  const padispo = () => {
    toast.error(
      "Ce Mode de Paiement n'est pas encore effectif, seul le service gratuit est disponible",
      {
        position: toast.POSITION.TOP_RIGHT,
      },
    );
  };
  // col-xs-12 col-sm-12 col-md-8 offset-md-2 col-lg-8 offset-lg-2
  return (
    // <div className="container">
    // d-flex justify-content-center
    // <div className="row ">
    <div className="card mb-3">
      <div className="card-header">
        <h2 className="display-5 text-center">Mode de Paiement</h2>
      </div>
      <div className="card-body d-flex justify-content-center ">
        {/* <div className="row "> */}
        <Form>
          <Form.Row>
            {/* <div className="col-12"> */}
            <ul style={{ Width: "360px" }} className="list-group">
              <li
                className="list-group-item "
                onClick={(e) => setMethode_paiement("primature")}
              >
                <div className="d-flex justify-content-between">
                  <Image
                    src={SEVIS_GRATIS}
                    style={{ marginLeft: "30px", height: "80px" }}
                  />

                  {methode_paiement == "primature" && (
                    <FaRegCheckSquare size={40} color={"cyan"} />
                  )}
                </div>
                <div>
                  {/* <h5 className="text-bold"> # Compte : XXXX-XXXX-XXX-XXX</h5> */}
                  <h3 className="font-weight-bold mt-1"> {`SÈVIS GRATIS `}</h3>
                </div>
              </li>
            </ul>
            {/* </div> */}
          </Form.Row>
          {/* <div className='container'> */}
          {methode_paiement && (
            <Form.Row className="px-2">
              <div className="container">
                <Button
                  className="btn-block"
                  style={{ marginTop: "20px", marginBottom: "10px" }}
                  variant="primary"
                  onClick={(e) => {
                    etapesuivante();
                  }}
                >
                  proceder au paiement
                </Button>
              </div>
            </Form.Row>
          )}

          {/* </div> */}
        </Form>
        {/* </div> */}
      </div>

      <div className="card-footer"></div>
    </div>
    // {/* </div> */}
    // </div>
  );
};

export default Mode_paiement;
